import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowSolicitationsProps<T> = {
  workflowId: string | undefined;
  filters?: {
    search?: string;
    page?: number;
    status?: string;
  };
  mapper?: (data: any) => T;
  enabled?: boolean;
}

export const useMaintenanceWorkflowSolicitations = <T,>({
  workflowId,
  filters: { search = '', page = 1, status } = {},
  mapper = Mapper.default<T>(),
  enabled,
}: UseMaintenanceWorkflowSolicitationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceWorkflowSolicitations', workflowId, search, page, status],
    queryFn: () => {
      return privateAxios.get(`/maintenance/workflows/${workflowId}/solicitations`, {
        params: {
          search,
          page,
          'q[status_eq]': status,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: (typeof enabled === 'boolean' ? enabled : true) && !!workflowId,
  });

  return { data, meta, ...rest }
}
